import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  CanMatchFn,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from './../services/authentication.service';

function authRedirectUrlTree(returnUrl: string): boolean | UrlTree {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);

  if (authenticationService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl } });
}

export const authCanActivate: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => authRedirectUrlTree(state.url);

export const authCanMatch: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const fullPath = `/${[route.path, ...segments.map((segment) => segment.path)]
    .filter(Boolean)
    .join('/')}`;
  return authRedirectUrlTree(fullPath);
};

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  canActivate = authCanActivate;
}
